export const keyToModifiedKeyMap: { [index: string]: string } = {
  allergies_medications: "allergies medications and food",
  allergies_medications_text: "allergies medications and food text",
};
